import * as Yup from "yup";

import { validateCPF } from "@/utils/validateCPF";

export const RegisterPromotoraFormValidationSchema = Yup.object().shape({
  // Campos básicos da promotora
  document: Yup.string()
    .required("CNPJ é obrigatório")
    .min(14, "CNPJ incompleto"),
  legalName: Yup.string()
    .min(3, "Razão social inválida")
    .required("Razão social é obrigatória"),
  businessName: Yup.string()
    .min(3, "Nome fantasia inválido")
    .required("Nome fantasia é obrigatório"),
  commission: Yup.number()
    .min(0, "Comissão não pode ser negativa")
    .max(100, "Comissão não pode ser maior que 100")
    .required("Comissão é obrigatória"),
  financialSettingsId: Yup.string().nullable(),
  financialSettingsConsignadoId: Yup.string().nullable(),

  // Dados do Usuário Master
  masterUserName: Yup.string()
    .min(3, "Nome inválido")
    .required("Nome do responsável é obrigatório"),
  masterUserLastName: Yup.string()
    .min(3, "Sobrenome inválido")
    .required("Sobrenome do responsável é obrigatório"),
  masterUserCpf: Yup.string()
    .required("CPF é obrigatório")
    .min(11, "CPF incompleto")
    .test("valid-cpf", "CPF Inválido", (value) => validateCPF(value || "")),
  masterUserEmail: Yup.string()
    .email("Email inválido")
    .required("Email é obrigatório"),
  masterUserPhone: Yup.string()
    .matches(/\(\d{2}\)\s\d{4,5}-\d{4}/, "Telefone inválido")
    .min(11, "Telefone incompleto")
    .required("Telefone é obrigatório"),
  masterUserPassword: Yup.string()
    .min(6, "A senha deve ter no mínimo 6 caracteres")
    .test("conditional-required", "Senha é obrigatória", function (value) {
      if (!this.parent.masterUserId && !value) {
        return false;
      }
      return true;
    }),
  masterUserRole: Yup.array()
    .min(1, "Pelo menos um papel deve ser selecionado")
    .required("Papel do usuário é obrigatório"),
})
.test(
  "at-least-one-financial-setting",
  "Salve a configuração financeira",
  function (values) {
    const { financialSettingsId, financialSettingsConsignadoId } = values;

    if (!financialSettingsId && !financialSettingsConsignadoId) {
      return this.createError({
        path: "financialSettingsId",
        message:
          "Salve a configuração financeira",
      });
    }

    return true;
  }
);
